import React from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { useNetworkStatus } from '../../../hooks/useNetworkStatus';
import { useTranslation } from 'react-i18next';
import './NetworkBanner.css';

/**
 * Bannière réseau pour l'app native.
 * - Offline : bandeau rouge persistant
 * - Reconnecté : bandeau vert qui disparaît après 3s
 */
const NetworkBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const { isOnline, justReconnected } = useNetworkStatus();

  if (isOnline && !justReconnected) return null;

  return (
    <div
      className={`network-banner ${isOnline ? 'network-banner--online' : 'network-banner--offline'}`}
      role="status"
      aria-live="polite"
    >
      {isOnline ? (
        <>
          <Wifi size={14} />
          <span>{t('network.reconnected')}</span>
        </>
      ) : (
        <>
          <WifiOff size={14} />
          <span>{t('network.offline')}</span>
        </>
      )}
    </div>
  );
};

export default NetworkBanner;
